<template>
    <div class="inner-wrapper">
        <div class="page-title quote-title">
            <h1 class="float-left">
                <router-link :to="{name: 'viewQuote', params:{id: $route.params.id}}" class="btn custom-btn" style="font-size: 26px; line-height: 26px; padding: 4px 8px 1px;"><i class="ri-arrow-left-s-line"></i>
                </router-link>

            </h1>
            <div class="title-right float-right">

            </div>
        </div>
        <div class="new-rfq">
            <div class="alert alert-success" role="alert" v-if="successMessage">
                {{ successMessage }}
            </div>

            <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                <ul>
                    <li v-for="(v, k) in commonErrors" :key="k">
                        <p v-for="error in v" :key="error" class="text-sm">
                            {{ error }}
                        </p>
                    </li>
                </ul>
            </div>




            <div class="custom-row" v-if="quotation != null">
                <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveQuoteDetails)" method="post" id="saveQuoteDetailsForm"
                          name="saveQuoteDetailsForm">
                          <div class="card">
                            <div class="card-header border-bottom-dashed p-4">
                                <div class="d-sm-flex">
                                    <div class="flex-grow-1">
                                            <img style="width:130px;" :src="asset('/admin/images/logo.png')" alt="logo"/>
                                        <div class="mt-sm-1 mt-2">
                                            <div class="addrss-left" v-if="meta_setting">
                                                <span>{{ meta_setting.address_1 }}</span><br/>
                                                <span>{{ meta_setting.address_2 }}</span><br/>
                                                <span>Tel. <b>{{ meta_setting.phone }}</b> </span> <br/>
                                                <span>Fax. <b>{{ meta_setting.fax }}</b> </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-shrink-0 mt-sm-0 mt-3">
                                        <div class="addrss-rght">
                                            <!--<h5>Quotation to</h5>-->
                                            <h6><span>
                                                <template v-if="customer_contact  != null && customer_contact.contact_name != ''">
                                                    {{ customer_contact.contact_name }} ({{ customer_detail.company_name }})
                                                </template>
                                                <template v-else>
                                                    {{ customer_detail.company_name }}
                                                </template>
                                            </span> </h6>
                                            <h6 v-if="customer_contact  != null"><span>Email:</span>{{ customer_contact.email }}</h6>
                                            <h6><span>Tel.</span> <span class="clno" v-if="customer_number"> {{ customer_number.contact_no }}</span> </h6>
                                            <span>{{ customer_detail.address }}</span>
                                        </div>

                                    </div>
                                </div>
                            </div><!--end card-header-->
                            <div class="card-body p-4">
                                <div class="row">
                                    <div id="error_alert" class="alert alert-success" style="display: none;">
                                        <strong>Please fill out * fields</strong>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="quotation_number" class="control-label">Quote Number</label>
                                            <input type="text" id="quotation_number" class="form-control input_text has-value"
                                                :value="'#'+quotation.quotation_number" readonly="readonly"/>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="terms" class="control-label">Terms</label>
                                            <input type="text" class="input_text has-value form-control" name="terms" id="terms"
                                                v-model="quoteDetailForm.terms"/>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="sale_rep_name" class="control-label">Sales REP</label>
                                            <input type="text" id="sale_rep_name" class="input_text has-value form-control"
                                                v-model="sale_rep_name" readonly=""/>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="valid_date" class="control-label">Lead Time</label>
                                            <input type="text" class="input_text has-value form-control" name="valid_date" id="valid_date"
                                                v-model="quoteDetailForm.valid_date"/>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="ship_via" class="control-label">Ship Via</label>
                                            <input type="text" class="input_text has-value form-control" name="ship_via" id="ship_via"
                                                v-model="quoteDetailForm.ship_via"/>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="fob" class="control-label">FOB</label>
                                            <input type="text" class="input_text has-value form-control" name="fob" id="fob"
                                                v-model="quoteDetailForm.fob"/>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group cylinder_amt">
                                            <label for="cylinder_amt" class="control-label">Total Cylinders</label>
                                            <input type="text" class="input_text has-value format_number form-control" name="cylinder_amt"
                                                @blur="saveCylinderData('amount')"
                                                id="cylinder_amt" v-model="quotation.cylinder_amt"/>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group cylinder_cost">
                                            <label for="cylinder_cost" class="control-label">Price per Cylinder</label>
                                            <input type="text" class="input_text has-value form-control" name="cylinder_cost"
                                                id="cylinder_cost"
                                                @blur="saveCylinderData('cost')"
                                                v-model="quotation.cylinder_cost"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="product-col">
                                <div class=" pd-btm-0">
                                    <div class="card-header">
                                        <div class="d-flex align-items-center">
                                            <h5 class="card-title flex-grow-1 mb-0">Product</h5>
                                       </div>
                                    </div>
                                    <div class="card-body p-3">
                                        <div v-if="editProductError" id="product_error_msg" class="alert alert-danger">{{editProductError}}</div>
                                        <div v-if="editProductSuccess" id="product_success_msg" class="alert alert-success">{{editProductSuccess}}</div>

                                        <div class="table-responsive product-create product-createsend">
                                            <template v-for="(product, index) in quote_products.filter((x) => x.count_tiers > 0)">
                                                <table class="table table-bordered table-custom send-quote-sec" :class="'product_table_' + product.product_id">
                                                    <tr class="tbl-blue" v-if="!editProductIds.includes(product.product_id)">
                                                        <td colspan="6" style="padding-left:0;">
                                                        <div class="removeBtnNew">
                                                        <span v-if="products_count > 1" class="remove-btn">
                                                            <a href="javascript:void(0)" @click="removeProduct(index, product)"><i class="ri-delete-bin-6-line"></i></a>
                                                        </span>
                                                            <!--{{ product.product_name }}-->
                                                            <a href="javascript:void(0)"
                                                                                @click="editProductIds.push(product.product_id)" class="edit-btn"> <!--<i class="ri-edit-box-line pe-1 align-middle edit-icon-sc edit_product_data"></i>--><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAVRJREFUSEvVlcFRwzAQRb8mBx8hFYAqSEowOBTAhbFvpAPoADqgA8IJTS4UQJykhKQCkQ5yzcERsx45Yyu2InmcGdDJI0v7/v5dexnOvNiZ46MTwK2QTwxQWYCP5T3flkVXAKNPGSqGdwDXtsyUwnie8En4JS97OywADPX5VRbgpgypACIhfwBctQi+1ncGACoQE6DoYBpzq3WG8nUWIKR7vR2WAAYKeJ7H/I32vAFNtmhAbhdTeJ0l/MUbYCov26KfqRZ5RkUdnDM4ZYsGVII7Z1AXnBQ27Te2aSTkUZF9g99N5fD7ga8KiNWiNsH3eyzSmPedAJGQpIR6++CtzZZISPqKL8ptbs2gsCwL0HfxvM5iJwApciloa4Dx6zhqxeJ9F4DG4ATxBvjOij8ByNvMV7lxfpPG/DBP6gbO5NRMsAjYMIXHWcLpt52vTkamLeP/D/gFqi0lKNTaSCgAAAAASUVORK5CYII="/></a>
                                                            <!--<span class="pull-right pr-nmbr">Tiers/Product
                                                                <span>{{ product.count_tiers }}</span>
                                                            </span>-->

                                                            <label  class="container-check">
                                                        <template v-if="product.hide_pdf == '0'">
                                                            <input type="checkbox"  v-on:click="hideProduct(product.product_id,$event)"  name="hide_pdf" :value="product.product_id" data-role="add-quotation" class="role-permission">Hide PDF
                                                        </template>
                                                        <template v-else>
                                                            <input type="checkbox"  checked v-on:click="hideProduct(product.product_id,$event)"  name="hide_pdf" :value="product.product_id" data-role="add-quotation" class="role-permission">Hide PDF
                                                        </template>
                                                        
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        </div>
                                                        </td>
                                                    </tr>

                                                    <tr class="tbl-blue" v-if="editProductIds.includes(product.product_id)">
                                                        <td colspan="6" style="padding-left:0;">
                                                            <div class="action-btn">

                                                                <a href="javascript:void(0);" @click="saveProduct(index, product.product_id)" class="save-btn">
                                                                    <i class="fas fa-save pull-right save-icon save_product_btn"></i>
                                                                </a>
                                                                <a href="javascript:void(0);" @click="cancelProductEdit(product.product_id)" class="close-btn">
                                                                    <i class="fa fa-times pull-right save-icon cancle_product_btn"></i>
                                                                </a>

                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <!--<tr v-if="editProductIds.includes(product.product_id)">
                                                        <td>
                                                            <input type="text" class="form-control" placeholder="Enter Product"
                                                                v-model="quote_products[index].product_name">
                                                        </td>
                                                        <td style="width:400px">
                                                            <textarea class="form-control" placeholder="Product Description"
                                                                    name="product_description"
                                                                    v-model="quote_products[index].description"></textarea>
                                                        </td>
                                                        <td style="padding: 0;" colspan="3"></td>
                                                        <td>
                                                            <div class="action-btn">
                                                            <a href="javascript:void(0);" @click="saveProduct(index, product.product_id)" class="save-btn">
                                                                <i class="fas fa-save pull-right save-icon save_product_btn"></i>
                                                            </a>
                                                            <a href="javascript:void(0);" @click="cancelProductEdit(product.product_id)" class="close-btn">
                                                                <i class="fa fa-times pull-right save-icon cancle_product_btn"></i>
                                                            </a>

                                                            </div>
                                                        </td>
                                                    </tr>-->

                                                    <tr class="grey-heading">
                                                        <th style="width:280px;">Item</th>
                                                        <th>Description</th>
                                                        <th style="width:100px;">SKU</th>
                                                        <th style="width:100px;">qty</th>
                                                        <th style="width:220px;">price</th>
                                                        <th style="width:220px;">Total</th>
                                                        <th></th>
                                                        <!--<th v-if="product.count_tiers >1 && quotation.status !=4"
                                                            style="width:25px;"></th>-->
                                                    </tr>
                                                    <tbody>
                                                    <tr :class="'product_view_' + product.product_id">
                                                        <td :rowspan="product.count_tiers+1" rowspan="0">
                                                            <template v-if="editProductIds.includes(product.product_id)">
                                                                <input type="text" class="form-control" placeholder="Enter Product"
                                                                       v-model="quote_products[index].product_name">
                                                            </template>
                                                            <template v-else>{{ product.product_name }}</template>

                                                        </td>
                                                        <td  :rowspan="product.count_tiers+1" rowspan="0">
                                                            <template v-if="editProductIds.includes(product.product_id)">

                                                                <ckeditor  v-model="quote_products[index].description" type="inline"
                                                                          :config="{ toolbar: [],ui: { top: 10, right: 10, bottom: 10, left: 10}}"></ckeditor>
                                                            </template>
                                                            <template v-else> <p v-html="product.description"></p></template>

                                                        </td>



                                                        <!-- <td>{{product.sku}}</td> -->

                                                        <template v-if="product.primary_tiers && product.primary_tiers.length">
                                                            <!--<td style="display: none;"></td>
                                                            <td style="display: none;"></td>-->
                                                            <td>
                                                               <template v-if="editProductIds.includes(product.product_id)">
                                                            <input type="text" class="form-control" v-on:change="changeSku(index, 0, 'primary_tiers')"
                                                                                   v-model="quote_products[index].primary_tiers[0].sku"
                                                                                   />
                                                            </template>
                                                            <template v-else>
                                                                    {{ quote_products[index].primary_tiers[0].sku }}
                                                                </template>
                                                            </td>
                                                            <td>

                                                            <template v-if="editProductIds.includes(product.product_id)">
                                                            <input type="text" v-on:change="changeTireQty(index, 0, 'primary_tiers')" class="form-control"
                                                                                   v-model="quote_products[index].primary_tiers[0].tier_qty"
                                                                                   />
                                                            </template>
                                                            <template v-else>
                                                                   {{ product.primary_tiers[0].tier_qty }}
                                                                </template>


                                                            </td>
                                                            <td class="tbl-lght-clr">
                                                                <template v-if="editProductIds.includes(product.product_id)">
                                                                    <div class="table-iinner-row">
                                                                        <div class="input-group mb-3">
                                                                            <span class="input-group-text">$</span>
                                                                            <input type="text" class="form-control"
                                                                                   v-model="quote_products[index].primary_tiers[0].selling"
                                                                                   v-on:change="calculate(index, 0, 'primary_tiers')"
                                                                                   v-on:keydown="checkDecimal($event, this)"/>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                                <template v-else>
                                                                    ${{quote_products[index].primary_tiers[0].selling}}
                                                                </template>

                                                            </td>
                                                            <td class="tbl-lght-clr">
                                                                <template v-if="editProductIds.includes(product.product_id)">
                                                                    <div class="table-iinner-row">
                                                                        <div class="input-group mb-3">
                                                                            <span class="input-group-text">$</span>
                                                                            <input type="text" class="form-control"
                                                                                   v-model="quote_products[index].primary_tiers[0].total_amt"
                                                                                   v-on:change="sellingCalculate(index, 0, 'primary_tiers')"
                                                                                   v-on:keydown="checkDecimal($event, this)"/>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                                <template v-else>
                                                                    ${{quote_products[index].primary_tiers[0].total_amt}}
                                                                </template>

                                                            </td>
                                                            <td v-if="product.count_tiers >1"
                                                                style="width:25px;">
                                                                <a href="javascript:void(0)" @click="tireRemove(index,product.primary_tiers,quote_products[index].primary_tiers[0].id)"><i class="fa fa-minus red-minus minusz"
                                                                id="remove_tire_old" ></i></a>
                                                            </td>
                                                        </template>
                                                    </tr>


                                                    <template v-for="(tier, tierIndex) in product.rest_tiers">
                                                        <tr>
                                                            <td>
                                                            <template v-if="editProductIds.includes(product.product_id)">
                                                            <input type="text" v-on:change="changeSku(index, tierIndex, 'rest_tiers')" class="form-control"
                                                                                   v-model="quote_products[index].rest_tiers[tierIndex].sku"
                                                                                   />
                                                            </template>
                                                            <template v-else>
                                                                    {{ quote_products[index].rest_tiers[tierIndex].sku }}
                                                                </template>

                                                            </td>
                                                            <td>

                                                            <template v-if="editProductIds.includes(product.product_id)">
                                                            <input type="text" v-on:change="changeTireQty(index, tierIndex, 'rest_tiers')" class="form-control"
                                                                                   v-model="quote_products[index].rest_tiers[tierIndex].tier_qty"
                                                                                   />
                                                            </template>
                                                            <template v-else>
                                                                   {{ tier.tier_qty }}
                                                                </template>


                                                            </td>
                                                            <td class="tbl-lght-clr">
                                                                <template v-if="editProductIds.includes(product.product_id)">
                                                                    <div class="table-iinner-row">
                                                                        <div class="input-group mb-3">
                                                                            <span class="input-group-text">$</span>
                                                                            <input type="text" class="form-control"
                                                                                   v-model="quote_products[index].rest_tiers[tierIndex].selling"
                                                                                   v-on:change="calculate(index, tierIndex, 'rest_tiers')"
                                                                                   v-on:keydown="checkDecimal($event, this)"/>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                                <template v-else>
                                                                    ${{quote_products[index].rest_tiers[tierIndex].selling}}
                                                                </template>

                                                            </td>
                                                            <td class="tbl-lght-clr">
                                                                <template v-if="editProductIds.includes(product.product_id)">
                                                                    <div class="table-iinner-row">
                                                                        <div class="input-group mb-3">
                                                                            <span class="input-group-text">$</span>
                                                                            <input type="text" class="form-control"
                                                                                   v-model="quote_products[index].rest_tiers[tierIndex].total_amt"
                                                                                   v-on:change="sellingCalculate(index, tierIndex, 'rest_tiers')"
                                                                                   v-on:keydown="checkDecimal($event, this)"/>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                                <template v-else>
                                                                    ${{quote_products[index].rest_tiers[tierIndex].total_amt}}
                                                                </template>

                                                            </td>
                                                            <td v-if="product.count_tiers >1"
                                                                style="width:25px;">
                                                                <a href="javascript:void(0)" @click="tireRemove(tierIndex,product.rest_tiers,quote_products[index].rest_tiers[tierIndex].id)"><i class="fa fa-minus red-minus minusz" ></i></a>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                    </tbody>
                                                </table>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h5 class="card-title flex-grow-1 mb-0">Terms & Condition</h5>
                                </div>
                            </div>
                            <div class="card-body p-3">
                                    <!--<ckeditor v-model="quoteDetailForm.terms_conditions"
                                            tag-name="textarea"
                                            :config="{}"></ckeditor>-->

                                <vue-editor v-model="quoteDetailForm.terms_conditions" :editorToolbar="getQuillToolbar()"></vue-editor>
                            </div>
                        </div>

                        <div class="card" v-if="customer_detail.customer_payment_terms">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h5 class="card-title flex-grow-1 mb-0">Payment Terms</h5>
                                </div>
                            </div>
                            <div class="card-body p-3">
                                <vue-editor v-model="quoteDetailForm.customer_payment_terms" :editorToolbar="getQuillToolbar()"></vue-editor>
                            </div>
                        </div>

                        <div class="btnrow text-right mb-2">
                            <div class="white-bg3">
                                <button type="button" class="btn btn-success" data-toggle="modal" data-target="#customerModal">Sent to
                                    Customer
                                </button>
                                <button type="submit" class="btn btn-info w-md">Save</button>
                                <button class="btn btn-primary" type="button" @click="download">Download PDF
                                </button>
                            </div>
                        </div>

                    </form>
                </ValidationObserver>

            </div>

        </div>

        <footer class="footer">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-6">
                            2022 © Superb.
                        </div>
                        <div class="col-sm-6">
                            <div class="text-right d-none d-sm-block">
                                All Rights Reserved.
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        <div class="modal fade" id="customerModal" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header p-3 bg-soft-info">
                        <h5 class="modal-title" id="sendModalLabel">Send To Customer</h5>
                        <button type="button" class="close" data-dismiss="modal"><i  class="ri-close-line"></i></button>
                    </div>
                    <div class="modal-body">
                        <div id="customer_error_alert" class="alert alert-danger" v-if="sendMailError">
                            {{sendMailError}}
                        </div>
                        <div class="form-group">
                            <label> Quote </label>
                            <input type="text" class="order-desc form-control" v-model="sendMailForm.quote_subject">

                        </div>


                        <div class="form-group">
                            <label>Customer email address</label>
                            <input type="email" name="customer_email" v-model="sendMailForm.customer_email" class="order-desc form-control">
                        </div>

                        <div class="form-group">
                            <div class="d-flex justify-content-between mt-1">
                                <a v-if="!isAddCC" class="badge badge-soft-primary fs-13 pull-right" href="javascript:void(0)" @click="isAddCC = true "><span class="lt-bl-bg">Add CC</span></a>
                                <a v-if="isAddCC" class="badge badge-soft-primary fs-13 pull-right" href="javascript:void(0)" @click="isAddCC = false; sendMailForm.add_cc =[] "><span class="lt-bl-bg">Remove CC</span></a>
                            </div>
                        </div>

                        <div class="form-group">
                            <!--<input v-if="isAddCC" type="text" class="order-desc form-control" v-model="sendMailForm.add_cc" placeholder="Please enter CC Email Address">-->
                            <!--<InputTag v-if="isAddCC" v-model="sendMailForm.add_cc" placeholder="Comma separated CC email addresses"
                                      validate="email" :add-tag-on-keys="[9,13, 32, 188]"
                                      :add-tag-on-blur="true"
                            ></InputTag>-->
                            <!--<CustomerSelect v-if="isAddCC" :customer="sendMailForm.add_ccSystemUsers" :multiple="true" @customerSelectedEvent="customerSelected"></CustomerSelect>-->
                            <v-select v-if="isAddCC" label="text" :filterable="false" :multiple="true" :taggable="true" :selectOnTab="true"
                                      v-model="sendMailForm.add_ccSystemUsers"
                                      :options="systemUsers"
                                      @search="onSystemUserSearch"
                                      @input="onSystemUserSelect"
                                      @selected="onSystemUserSelect"
                                      @deselected ="onSystemUserDeSelect">
                                <template slot="no-options">
                                    type to search vendors..
                                </template>
                                <template slot="option" slot-scope="option">
                                    <div class="d-center" v-html="option.html">
                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center" v-html="option.html ? option.html : option.text">
                                    </div>
                                </template>
                            </v-select>
                        </div>
                        <div class="mt-3 mb-3">
                            <!--Hello--> <!-- <b>#Customer Name,</b> -->
                            <ckeditor v-model="sendMailForm.message_body"
                                      tag-name="textarea"
                                      placeholder="Please Enter Message"
                                      :config="editorConfigMin"></ckeditor>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-lg-12">
                                <div class="add-attchmnt">
                                    <label>Add Attachment : </label>
                                    <div class="form-group files customer_mail_files color">
                                        <vue-dropzone :options="dropzoneOptions"
                                                      :id="'item-dropzone-attach'"
                                                      v-on:vdropzone-success="(file, response) => afterUploadComplete(file, response)">
                                        </vue-dropzone>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--<div class="row mt-5">
                            <div class="col-md-12 col-lg-12">
                                <template v-if="sendMailForm.quote_attachments.length > 0">
                                    <template v-for="(item, index) in sendMailForm.quote_attachments">
                                        <div class="pdf-dwn-sec line-hgt" :class="'vendor_num_' + index">
                                            <img v-if="item.image_type=='1'" :src="'/quote_files/'+item.file_name" style="width:70px;height:70px">
                                            {{item.file_name}}
                                            <a href="javascript:void(0)" class="trash_btn"
                                               @click="deleteQuoteAttachFile(index)"><i  class="ri-delete-bin-6-line"></i></a>
                                            <a :href="'/quote_files/'+item.file_name" class="pull-right"><i  class="ri-download-2-line"></i> download></a>
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>-->
                        <div class="row mt-5" id="add_customer_files">
                            <div class="col-md-12 col-lg-12">
                                <template v-if="attached_files.length > 0">
                                    <template v-for="(item, index) in attached_files">
                                        <div class="pdf-dwn-sec line-hgt" :class="'vendor_num_' + index">
                                            <img v-if="item.image_type=='1'" :src="'/quote_files/'+item.name" style="width:70px;height:70px">
                                            {{item.name}}
                                            <a href="javascript:void(0)" class="trash_btn"
                                               @click="deleteAttachFile(index)"><i  class="ri-delete-bin-6-line"></i></a>
                                            <a :href="'/quote_files/'+item.name" class="pull-right"><i  class="ri-download-2-line"></i> download></a>
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>

                        <div class="custom-slect-drop">

                        </div>
                        <div class="button-blk pull-left mt-3">
                            <button class="btn btn-danger me-1" data-dismiss="modal"> Cancel</button>
                            <button class="btn btn-primary" @click="handleSendQuoteBtnClick">Send Mail</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import axios from "axios";
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Vue from "vue";
import InputTag from "vue-input-tag";
//import { VueEditor } from 'vue2-quill-editor';
import { VueEditor } from "vue2-editor";
import CustomerSelect from "../../components/CustomerSelect";

export default {
    name: "SendQuoteCustomer",
    components: {
        ValidationProvider,
        ValidationObserver,
        vueDropzone: vue2Dropzone,
        InputTag,
        VueEditor,
        CustomerSelect
    },
    created() {
        this.id = this.$route.params.id;
        this.getSendToCustomerPageData();
    },
    mounted() {

    },
    data() {
        return {
            id: null,
            smtp_user: null,
            quotation: null,
            sale_rep_name: null,
            customer_contact: null,
            quote_products: [],
            products_count: null,
            customer_number: null,
            quote_detail: null,
            customer_detail: null,
            meta_setting: null,
            user: null,

            quoteDetailForm: {
                quote_id: this.$route.params.id,
                id: null,
                terms: null,
                ship_via: null,
                valid_date: null,
                fob: null,
                terms_conditions: null,
                customer_payment_terms: null
            },

            editProductIds: [],
            editProductError: null,
            editProductSuccess: null,

            isAddCC: false,
            sendMailError: null,
            systemUsers:[],
            sendMailForm:{
                customer_email: null,
                quote_id: this.$route.params.id,
                quote_subject: null,
                message_body: "Hello, <p>Please Enter Message</p>",
                attached_files: [],
                quote_attachments: [],
                add_cc: [],
                add_ccSystemUsers: []
            },

            dropzoneOptions: {
                url: window.route('quote.addAttachments'),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 10,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem('token'),
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                }
            },
            attached_files: [],
            editorConfigMin: {
                toolbar: [
                    [ 'Source', '-', 'Bold', 'Italic' ],
                    [ 'Styles', 'Format', 'Font', 'FontSize' ],
                ]
            },
            editorConfigNoToolBar: {
                toolbar: [],
                ui: { top: 10, right: 10, bottom: 10, left: 10}
            },
            customQuillNoToolbar:[
                ['bold', 'italic', 'underline'],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                ['image', 'code-block']
            ],
            customQuillToolbar:[
                [{
                    'font': []
                }, {
                    'size': []
                }],
                ['bold', 'italic', 'underline', 'strike'],
                [{
                    'color': []
                }, {
                    'background': []
                }],
                [{
                    'script': 'super'
                }, {
                    'script': 'sub'
                }],
                [{
                    'header': [false, 1, 2, 3, 4, 5, 6]
                }, 'blockquote', 'code-block'],
                [{
                    'list': 'ordered'
                }, {
                    'list': 'bullet'
                }, {
                    'indent': '-1'
                }, {
                    'indent': '+1'
                }],
                ['direction', {
                    'align': []
                }],
                ['link', 'image', 'video'],
                ['clean']
            ]
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        /*customerSelected(event){
            //console.log(event);
            if(event != null) {
                this.sendMailForm.add_ccSystemUsers = event;
            } else {
                this.sendMailForm.add_ccSystemUsers = [];
            }

            this.sendMailForm.add_cc = [];
            if (event.length) {
                event.forEach((item) => {
                    if(!this.sendMailForm.add_cc.includes((item.contact_email))) {
                        this.sendMailForm.add_cc.push(item.contact_email);
                    }
                });
            }
        },*/

        hideProduct(productId,event){
            let status = 0;
            if (event.target.checked) {
                //alert('isSelected');
                 status = 1;
            }
            else{
                //alert('not selected');
            }
            let self = this;
            return axios.post(window.route('hideProductPdf'), {product_id:productId,hide_pdf:status, quote_id: self.quotation.id}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(data.data);
                        this.getSendToCustomerPageData();
                        //$("#customerModal").modal('hide');
                        setTimeout(() => {
                            this.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        
        onSystemUserSelect(event){
            console.log(event)
            this.sendMailForm.add_cc = [];
            if (event.length) {
                event.forEach((item) => {
                    let email = item.email ? item.email : item.text;
                    if(!this.sendMailForm.add_cc.includes((email))) {
                        this.sendMailForm.add_cc.push(email);
                    }
                });
            }
        },
        onSystemUserDeSelect(event){
            this.sendMailForm.add_cc = [];
            if (event.length) {
                event.forEach((item) => {
                    let email = item.email ? item.email : item.text;
                    if(!this.sendMailForm.add_cc.includes((email))) {
                        this.sendMailForm.add_cc.push(email);
                    }
                });
            }
        },
        onSystemUserSearch(search, loading) {
            if(search.length) {
                if(this.systemUsers.length == 0) {
                    loading(true);
                    this.searchSystemUser(loading, search, this);
                }
            }
        },
        searchSystemUser: _.debounce((loading, search, vm) => {
            return axios.post(window.route('searchSaleUser'), {searchTerm: search}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        vm.systemUsers = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
        tireRemove(index,product,tireId){
            console.log("tireId ",tireId);
            product.splice(index,1);

            let self = this;
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if(confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios.post(window.route('deleteProductTier'), {id: tireId }, {
                            validateStatus: function (status) {
                                return status < 500; // Resolve only if the status code is less than 500
                            }
                        })
                            .then(({data}) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.setSuccessMessage(data.data);
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                   // self.getSendToCustomerPageData();
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                            })
                            .finally(() => {
                                self.setLoading(false);

                            });
                    }

                }
            });


            //alert("ddd");
        },
        removeProduct(index, item){

            console.log("item",item);
            let self = this;
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete product?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if(confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios.post(window.route('deleteProduct'), {id: item.product_id, quote_id: self.quotation.id }, {
                            validateStatus: function (status) {
                                return status < 500; // Resolve only if the status code is less than 500
                            }
                        })
                            .then(({data}) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.setSuccessMessage(data.data);
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                    self.getSendToCustomerPageData();
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                            })
                            .finally(() => {
                                self.setLoading(false);

                            });
                    }

                }
            });
        },
        deleteQuoteAttachFile(id){
            // this.vendor_files.splice(id, 1);
            this.sendMailForm.quote_attachments.splice(id, 1);
        },
        deleteAttachFile(id){
            // console.log('deleteAttachFile', id)
            // this.vendor_files.splice(id, 1);
            this.sendMailForm.attached_files.splice(id, 1);
            this.attached_files.splice(id, 1);
        },
        afterUploadComplete(file, response) {
            if(response.success==true){
                this.attached_files.push({
                    name: response.name,
                    size: response.size,
                    src: response.src,
                    image_type: response.image_type,
                    attachment_id: response.attachment_id,
                });
                this.sendMailForm.attached_files.push(response.name);
            } else {
                this.setErrorMessage('File not uploaded successfully');
            }
        },
        handleSendQuoteBtnClick(){
            this.sendMailError = null;

            if(this.sendMailForm.customer_email =='')
            {
                this.sendMailError = "Please enter customer email";
            }

            if(this.sendMailForm.quote_subject =='')
            {
                this.sendMailError = "Please enter quote subject";
            }
            if(this.sendMailForm.message_body =='')
            {
                this.sendMailError = "Please enter message body";
            }
            if(this.sendMailError != null)
            {
                return false;
            }

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let sendMailForm = _.cloneDeep(this.sendMailForm);

            /*sendMailForm.add_cc = [];
            if(this.sendMailForm.add_cc != null && this.sendMailForm.add_cc != "") {
                sendMailForm.add_cc = this.sendMailForm.add_cc.split(",");
            }*/

            return axios.post(window.route('send_mail_customer'), sendMailForm, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(data.data);
                        $("#customerModal").modal('hide');
                        setTimeout(() => {
                            this.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        cancelProductEdit(product_id){
            this.editProductIds.splice(this.editProductIds.indexOf(product_id), 1);
        },
        saveProduct(index, product_id){
            this.editProductError = null;

            if(this.quote_products[index].product_name =='')
            {
                this.editProductError = "Please enter product name";
            }
            if(this.quote_products[index].description =='')
            {
                this.editProductError = "Please enter product description";
            }
            if(this.editProductError != null)
            {
                return false;
            }

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let payload = {
                product_id: this.quote_products[index].product_id,
                quote_id: this.quotation.id,
                product_name: this.quote_products[index].product_name,
                product_desc: this.quote_products[index].description,
            };

            return axios.post(window.route('updateProductData'), payload, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.editProductSuccess = "Product data saved successfully.";
                        this.cancelProductEdit(product_id);
                        setTimeout(() => {
                            this.editProductSuccess = null;
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        calculate(index, tierIndex, tierType) {
            let peice = this.quote_products[index][tierType][tierIndex].peices;
            let selling = this.quote_products[index][tierType][tierIndex].selling;
            if (selling > 0) {
                let total_amt = (selling * peice).toFixed(2);

                this.quote_products[index][tierType][tierIndex].total_amt = total_amt;
                this.updatePrice(index, tierIndex, tierType);
            }
        },
         changeSku(index, tierIndex, tierType) {
            console.log('index ',index);
           console.log("checking ",this.quote_products[index][tierType][tierIndex].sku);
            console.log("quote_products ",this.quote_products);
            this.updatePrice(index, tierIndex, tierType);
        },

        changeTireQty(index, tierIndex, tierType){

            let peice = this.quote_products[index][tierType][tierIndex].tier_qty;
            let selling = this.quote_products[index][tierType][tierIndex].selling;
            if (selling > 0) {
                let total_amt = (selling * peice).toFixed(2);

                this.quote_products[index][tierType][tierIndex].total_amt = total_amt;
                this.updatePrice(index, tierIndex, tierType);
            }


            this.updatePrice(index, tierIndex, tierType);
        },

        sellingCalculate(index, tierIndex, tierType) {
            let peice = this.quote_products[index][tierType][tierIndex].peices;
            let total_amt = this.quote_products[index][tierType][tierIndex].total_amt;
            if (total_amt > 0) {
                let selling = (total_amt / peice).toFixed(2);

                this.quote_products[index][tierType][tierIndex].selling = selling;
                this.updatePrice(index, tierIndex, tierType);
            }
        },
        updatePrice(index, tierIndex, tierType) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let payload = {
                product_id: this.quote_products[index].product_id,
                tier_id: this.quote_products[index][tierType][tierIndex].id,
                selling: this.quote_products[index][tierType][tierIndex].selling,
                total_amt: this.quote_products[index][tierType][tierIndex].total_amt,
                product_sku: this.quote_products[index][tierType][tierIndex].sku,
                product_tier_value: this.quote_products[index][tierType][tierIndex].tier_qty
            };

            return axios.post(window.route('updateTierPrice'), payload, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(data.data);
                        this.getSendToCustomerPageData();
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getSendToCustomerPageData() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('SendToCustomerPage', {id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.smtp_user = data.data.smtp_user;
                        this.quotation = data.data.quotation;
                        this.sale_rep_name = data.data.sale_rep_name;
                        this.customer_contact = data.data.customer_contact;
                        this.quote_products = data.data.quote_products.filter((x) => x.count_tiers > 0);
                        this.products_count = data.data.products_count;
                        this.customer_number = data.data.customer_number;
                        this.quote_detail = data.data.quote_detail;
                        this.customer_detail = data.data.customer_detail;
                        this.meta_setting = data.data.meta_setting;
                        this.user = data.data.user;

                        this.quoteDetailForm.quote_id = this.$route.params.id;

                        if (this.quote_detail) {
                            this.quoteDetailForm.id = this.quote_detail.id;
                            this.quoteDetailForm.terms = this.quote_detail.terms;

                            if(this.quote_detail.valid_date == '' || this.quote_detail.valid_date == null ){
                                this.quoteDetailForm.valid_date = this.meta_setting.lead_time;
                            }
                            else{
                                this.quoteDetailForm.valid_date = this.quote_detail.valid_date;
                            }

                            this.quoteDetailForm.ship_via = this.quote_detail.ship_via;
                            this.quoteDetailForm.fob = this.quote_detail.fob;
                            this.quoteDetailForm.terms_conditions = this.quote_detail.terms_conditions ? this.quote_detail.terms_conditions.replace(/\n/g,' ') : this.quote_detail.terms_conditions;
                            if(this.quote_detail.payment_terms == '' || this.quote_detail.payment_terms == null ){
                                this.quoteDetailForm.customer_payment_terms = this.customer_detail.customer_payment_terms;
                            }
                            else{
                                this.quoteDetailForm.customer_payment_terms = this.quote_detail.payment_terms;
                            }

                            
                        } else {
                            this.quoteDetailForm.customer_payment_terms = this.customer_detail.customer_payment_terms;
                            this.quoteDetailForm.valid_date = this.meta_setting.lead_time;
                            this.quoteDetailForm.terms_conditions = this.meta_setting.terms ? this.meta_setting.terms.replace(/\n/g,' ') : this.meta_setting.terms;
                        }

                        //this.sendMailForm.quote_subject = `${this.meta_setting.quote_send_to_customer_subject} Quote #${this.quotation.quotation_number}`;
                        this.sendMailForm.quote_subject = this.meta_setting.quote_send_to_customer_subject.replace("__QUOTE_NUMBER__", this.quotation.quotation_number);
                        if(this.quotation.quote_name != null && this.quotation.quote_name != '') {
                            this.sendMailForm.quote_subject += ' '+this.quotation.quote_name;
                        } else {
                            let product_name = '';
                            this.quote_products.forEach((x) => {
                                product_name += x.product_name + ' ';
                            });
                            this.sendMailForm.quote_subject += ' '+product_name;
                        }

                        if(this.meta_setting.quote_send_to_customer_body) {
                            this.sendMailForm.message_body = this.meta_setting.quote_send_to_customer_body;
                        }

                        this.sendMailForm.message_body = this.sendMailForm.message_body.replace("__QUOTE_NUMBER__", this.quotation.quotation_number);

                        let contact_name = "";
                        let company_name = "";
                        if(this.customer_detail) {
                            company_name = this.customer_detail.company_name;
                        }

                        if(this.customer_contact) {
                            this.sendMailForm.customer_email = this.customer_contact.email;
                            contact_name = this.customer_contact.contact_name;
                        }

                        this.sendMailForm.quote_subject = this.sendMailForm.quote_subject.replace('__CUSTOMER_NAME__', contact_name);
                        this.sendMailForm.quote_subject = this.sendMailForm.quote_subject.replace('__CUSTOMER_COMPANY_NAME__', company_name);


                        this.sendMailForm.message_body = this.sendMailForm.message_body.replace('__CUSTOMER_NAME__', contact_name);
                        this.sendMailForm.message_body = this.sendMailForm.message_body.replace('__CUSTOMER_COMPANY_NAME__', company_name);

                        if(data.data.quote_attachments) {
                            //this.sendMailForm.quote_attachments = _.cloneDeep(data.data.quote_attachments);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        download(d) {
            let url = window.route('DownloadQuotePdf', {
                id: this.quotation.id
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url, {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    let fileName = '';
                    if(this.quotation.quote_name) {
                        fileName = `Quote #${this.quotation.quotation_number} ${this.quotation.quote_name}.pdf`;
                    } else {
                        let subject = '';
                        this.quote_products.forEach((prod) => {
                            subject += ` ${prod.product_name}`;
                        });
                        fileName = `Quote #${this.quotation.quotation_number}${subject}.pdf`;
                    }
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        saveQuoteDetails() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios.post(window.route('saveQuoteDetails'), this.quoteDetailForm, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.getSendToCustomerPageData();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        saveCylinderData(dataType) {
            let payload = {cylinder_cost: this.quotation.cylinder_cost, quote_id: this.quotation.id};
            if (dataType == 'amount') {
                payload = {cylinder_amt: this.quotation.cylinder_amt, quote_id: this.quotation.id};
            }

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios.post(window.route('add_cylinder_data'), payload, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },

    },
    computed: {
        ...mapState([
            'userState',
            'quotationState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading'
        ])
    },
    watch: {
        'form.customer_id': {
            handler: function (after, before) {

            },
            deep: true,
        },
    }
}
</script>

<style scoped>

</style>
